import './resultats.scss';
import '../../Inclusions/entetes/_entete.js';
import '../../Inclusions/pieds/_pied.js';
import '../../Inclusions/menus/_menu.js';
import { initRecherchePlaceholder } from '../../../../src/_js/_recherche-placeholder.js';
initRecherchePlaceholder();

document.addEventListener('DOMContentLoaded', () => {
  const liste = document.getElementById('resultats-liste');
  if (!liste) return;

  const items           = Array.from(liste.querySelectorAll('li'));
  const donneesItems    = items.map(item => ({
    type:     (item.dataset.type || '').toLowerCase(),
    chantier: item.dataset.chantiers || '',
    sujets:   new Set((item.dataset.sujets || '').split(/[\s,;]+/).filter(Boolean)),
  }));
  const groupes         = document.querySelectorAll('.filtres-groupe');
  const panneaux        = document.querySelectorAll('.filtres-panneau');
  const typeBadges      = document.querySelectorAll('.filtre-type-badge');
  const selectionneZone = document.querySelector('.filtres-actifs-selectionne');
  const pastillesListe  = document.querySelector('.filtres-actifs-liste');
  const effacerBtn      = document.querySelector('.filtres-actifs-effacer');
  const compteur        = document.getElementById('resultats-nb');
  // État : types actifs (badge toggles)
  const typesActifs = new Set();

  // Valeurs des cases cochées d'un panneau (chantiers ou thèmes)
  const cochees = idPanneau => Array.from(document.querySelectorAll(`#${idPanneau} .filtre-case:checked`), c => c.value);

  // ── Fermer tous les panneaux ────────────────────────────────────────────
  function fermerTousLesPanneaux() {
    panneaux.forEach(p => { p.hidden = true; });
    groupes.forEach(g => g.classList.remove('is-open'));
  }

  // ── Badges de type ──────────────────────────────────────────────────────
  typeBadges.forEach(badge => {
    badge.addEventListener('click', () => {
      const type = badge.dataset.type;
      if (typesActifs.has(type)) {
        typesActifs.delete(type);
        badge.classList.remove('is-active');
      } else {
        typesActifs.add(type);
        badge.classList.add('is-active');
      }
      // État annoncé aux lecteurs d'écran (#52)
      badge.setAttribute('aria-pressed', String(typesActifs.has(type)));
      filtrer();
    });
  });

  // ── Ouverture/fermeture des panneaux au clic ────────────────────────────
  groupes.forEach(groupe => {
    const titre = groupe.querySelector('.filtres-groupe-titre');
    if (!titre) return;

    titre.addEventListener('click', e => {
      e.stopPropagation();
      const idPanneau = groupe.dataset.panneau;
      const panneau = idPanneau ? document.getElementById(idPanneau) : null;
      if (!panneau) return;

      const estOuvert = !panneau.hidden;
      fermerTousLesPanneaux();
      if (!estOuvert) {
        panneau.hidden = false;
        groupe.classList.add('is-open');
      }
    });
  });

  // ── Boutons fermer (×) ──────────────────────────────────────────────────
  document.querySelectorAll('.filtres-panneaux .btn-fermer').forEach(btn => {
    btn.addEventListener('click', e => {
      e.stopPropagation();
      fermerTousLesPanneaux();
    });
  });

  // ── Ouverture des sous-thèmes ───────────────────────────────────────────
  document.querySelectorAll('.index-nb-enfants').forEach(btn => {
    btn.addEventListener('click', () => {
      const ouvert = btn.closest('.index-niv2').classList.toggle('is-open');
      btn.setAttribute('aria-expanded', ouvert);
    });
  });

  // ── Filtres chantiers et thèmes (choix multiple, le panneau reste ouvert) ─
  document.querySelectorAll('.filtre-case').forEach(caseFiltre => {
    caseFiltre.addEventListener('change', () => {
      synchroniserHierarchie(caseFiltre);
      filtrer();
      mettreAJourPastille();
    });
  });

  // Un parent coché ou décoché entraîne tous ses enfants ; à l'inverse, un parent
  // affiche coché (tous les enfants cochés), partiel (quelques-uns) ou décoché.
  function synchroniserHierarchie(c) {
    const zone = c.closest('.index-niv3, .index-niv2, .index-niv1');
    zone?.querySelectorAll('.filtre-case').forEach(e => {
      if (e !== c) {
        e.checked = c.checked;
        e.indeterminate = false;
      }
    });
    c.indeterminate = false;

    [c.closest('.index-niv2'), c.closest('.index-niv1')].forEach(z => {
      const parent = z?.querySelector('.filtre-case');
      if (!parent || parent === c) return;

      const enfants  = Array.from(z.querySelectorAll('.filtre-case')).slice(1);
      const nbCoches = enfants.filter(e => e.checked).length;
      parent.checked       = nbCoches === enfants.length;
      parent.indeterminate = nbCoches > 0 && !parent.checked;
    });
  }

  // Vrai si un parent de cette case est coché (sa pastille remplace alors celle de l'enfant)
  function parentCoche(c) {
    return ['.index-niv2', '.index-niv1'].some(sel => {
      const parent = c.closest(sel)?.querySelector('.filtre-case');
      return parent && parent !== c && parent.checked;
    });
  }

  // Fermer panneaux au clic extérieur
  document.addEventListener('click', e => {
    if (!e.target.closest('.resultats-filtres') && !e.target.closest('.filtres-panneaux')) {
      fermerTousLesPanneaux();
    }
  });

  // ── Logique de filtrage ──────────────────────────────────────────────────
  function filtrer() {
    let nb = 0;
    const chantiers = cochees('panneau-chantiers');
    const themes    = cochees('panneau-sujets');

    items.forEach(item => {
      let visible = true;

      if (typesActifs.size > 0) {
        visible = visible && typesActifs.has((item.dataset.type || '').toLowerCase());
      }

      if (chantiers.length > 0) {
        visible = visible && chantiers.includes(item.dataset.chantiers);
      }

      if (themes.length > 0) {
        const sujets = (item.dataset.sujets || '').split(/[\s,;]+/).filter(Boolean);
        visible = visible && themes.some(t => sujets.includes(t));
      }

      item.style.display = visible ? '' : 'none';
      if (visible) nb++;
    });

    if (compteur) {
      compteur.textContent = nb + (nb !== 1 ? ' parutions' : ' parution');
    }

    mettreAJourDisponibilite();
  }

  // ── Disponibilité des choix (grise ceux qui ne donneraient aucun résultat) ─
  function mettreAJourDisponibilite() {
    const chantiers = cochees('panneau-chantiers');
    const themes    = cochees('panneau-sujets');

    const passeTypes    = d => typesActifs.size === 0 || typesActifs.has(d.type);
    const passeChantier = d => chantiers.length === 0 || chantiers.includes(d.chantier);
    const passeThemes   = d => themes.length === 0 || themes.some(t => d.sujets.has(t));

    const chantiersDispo = new Set();
    const themesDispo    = new Set();
    donneesItems.forEach(d => {
      if (passeTypes(d) && passeThemes(d))   chantiersDispo.add(d.chantier);
      if (passeTypes(d) && passeChantier(d)) d.sujets.forEach(s => themesDispo.add(s));
    });

    document.querySelectorAll('.filtre-case').forEach(c => {
      const dispo = c.closest('#panneau-chantiers') ? chantiersDispo : themesDispo;
      const indisponible = !dispo.has(c.value) && !c.checked;
      c.disabled = indisponible;
      c.closest('label').classList.toggle('is-disabled', indisponible);
    });
  }

  // ── Pastille filtre sélectionné ──────────────────────────────────────────
  function mettreAJourPastille() {
    if (!pastillesListe || !selectionneZone) return;
    pastillesListe.innerHTML = '';

    const choix = [];
    document.querySelectorAll('.filtre-case:checked').forEach(c => {
      if (parentCoche(c)) return;
      choix.push({
        label: c.closest('label').textContent.trim(),
        retirer: () => { c.checked = false; synchroniserHierarchie(c); },
      });
    });

    selectionneZone.hidden = choix.length === 0;

    choix.forEach(({ label, retirer }) => {
      const pastille = document.createElement('span');
      pastille.className = 'filtres-actifs-pastille';

      const texte = document.createElement('span');
      texte.textContent = label;

      const supprimer = document.createElement('button');
      supprimer.className = 'pastille-supprimer';
      supprimer.setAttribute('aria-label', 'Retirer ' + label);
      supprimer.textContent = '×';
      supprimer.addEventListener('click', () => {
        retirer();
        filtrer();
        mettreAJourPastille();
      });

      pastille.appendChild(texte);
      pastille.appendChild(supprimer);
      pastillesListe.appendChild(pastille);
    });
  }

  if (effacerBtn) {
    effacerBtn.addEventListener('click', () => {
      document.querySelectorAll('.filtre-case').forEach(c => { c.checked = false; c.indeterminate = false; });
      filtrer();
      mettreAJourPastille();
    });
  }

  filtrer();
});